import { useEffect } from "react";
import { useAuth } from "../context/AuthProvider";

export default function Logout() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return null;
}
